/**
 * 测一测
 */
import service from '@/request/api'; // 导入api接口
import { Toast } from 'vant';

export default {
  namespaced: true,
  state: {
    phone: '',
    catCode: '',
    nextStep: false,
  },
  mutations: {
    updateState(state, obj) {
      // eslint-disable-next-line
            for (const key in obj) {
        state[key] = obj[key];
      }
    },
  },
  actions: {
    getCode(context) {
      service.Calculation.calculationCode({
        phone: context.rootState.calculation.phone,
        type: 8,
      }).then((res) => {
        if (res.success) {
          Toast('发送成功');
        } else {
          Toast(res.returnMessage);
        }
      }).catch(() => {
        Toast('小望已离开地球，请稍后重试！');
      });
    },
    subUserInfo(context, data) {
      service.Calculation.subUserInfoData(data).then((res) => {
        if (res.success) {
          context.commit('updateState', {
            nextStep: true,
          });
        } else {
          Toast(res.returnMessage);
        }
      }).catch(() => {
        Toast('小望已离开地球，请稍后重试！');
      });
    },
  },
  getters: {
    nextStep: (state) => state.nextStep,
  },
};
